<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">COVID-19 Impact</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>Bizminer reports now adjust our raw data to better reflect the most recent changes in local and national industry
                markets. We accomplish this by integrating additional Census Bureau data with our proprietary content, allowing
                us to accelerate and refine month-to-month trends. Our content displays the new data in three ways: <br> <br><br>
                * Our employment data is adjusted to better reflect the most recent realities at local and national levels <br> <br>
                * Updates of industry market sales averages and total market volume are accelerated by one month and renamed as
                Trailing Twelve Month (TTM) values <br> <br>
                * New content will display monthly (not annual) industry sales and employment from year-end 2019 through both
                Preliminary Update and Advance Projection months. <br> <br>
                These enhanced protocols will be most obvious in our Industry Market Trend series, including a new “Monthly
                Change” tab in each report. Similarly, snapshot reports like the SWOT-XPRESS, Competitive Market Narrative
                and Company Insight series will reflect our new update protocols and add content for Preliminary Update and
                Advance months.<br> <br> <br>
                Shorter projections are more detailed and accurate than longer-term projections. Preliminary Update data is
                calculated on a more accurate and detailed basis than the Advance Projection month, which will adjust as it
                moves to “update month” status the following month. Interpret and utilize this content accordingly.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div class="md-transparent finanical-report-messages">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 p-0">
                  <md-card class="if_card">
                    <md-card-header>COVID-19 Impact</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100  blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Month-to-Month
                                  Employment (Dec-19={{
                                  newCovid['Dec']&&newCovid['Dec']['19']?newCovid['Dec']['19'].Employment:''}})</div>
                              </h4>
                              <!-- <h4 class="title text-left">Month-to-Month Employment-Sales</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumns" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovid" :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumns" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumns[index]] ?
                                        element[yearsCovidColumns[index]].Employment:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-size-100  blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Month-to-Month
                                  Sales
                                  (Dec-19={{newCovid['Dec']&&newCovid['Dec']['19']?newCovid['Dec']['19'].Sales:''}})
                                </div>
                              </h4>
                              <!-- <h4 class="title text-left">Month-to-Month Employment-Sales</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumns" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovid" :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumns" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumns[index]] ? element[yearsCovidColumns[index]].Sales:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-size-100 blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">% Change from
                                  Dec-19 Employment (Dec-19={{ newCovidChange['Dec'] &&
                                  newCovidChange['Dec']['19']?newCovidChange['Dec']['19'].Employment:''}})</div>
                              </h4>
                              <!-- <h4 class="title text-left">% Change from Dec-19</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumnsChange" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovidChange"
                                      :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumnsChange" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumnsChange[index]] ?
                                        element[yearsCovidColumnsChange[index]].Employment:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-size-100 blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">% Change from
                                  Dec-19 Sales (Dec-19={{ newCovidChange['Dec'] &&
                                  newCovidChange['Dec']['19'] ? newCovidChange['Dec']['19'].Sales:''}})</div>
                              </h4>
                              <!-- <h4 class="title text-left">% Change from Dec-19</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                  <md-table table-header-color="blue" class="profit-and-loss-table">
                                    <md-table-row>
                                      <md-table-head></md-table-head>
                                      <md-table-head v-for="elem in yearsCovidColumnsChange" :key="elem">20{{ elem }}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row slot="md-table-row" v-for="(element,month) in newCovidChange"
                                      :key="month">
                                      <md-table-cell class="md-table-side-label">{{ month }}
                                      </md-table-cell>
                                      <md-table-cell v-for="(elem,index) in yearsCovidColumnsChange" :key="elem+index"
                                        class="md-table-side-label">{{
                                        element[yearsCovidColumnsChange[index]] ?
                                        element[yearsCovidColumnsChange[index]].Sales:''}}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card header-animation="false" :chart-data="covidImpactChangeLineChart.data"
                                :chart-options="
                                  covidImpactChangeLineChart.options
                                " chart-type="Bar" header-icon chart-inside-content no-footer background-color="blue">
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Monthly
                                      Change Index (Dec-19=1.00)</div>
                                  </h4>
                                  <!-- <h4 class="title">Monthly Change Index (Dec-19=1.00)</h4> -->
                                </template>
                              </chart-card>
                            </md-card-content>
                          </md-card>
                        </div>
                        <md-card class="md-card-profile px-4">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                <md-icon class="color-white">article</md-icon> Covid Impact
                              </div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100">
                                <div class="extra_space">
                                  <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                  </h4>-->
                                  <p>
                                    Bizminer reports now adjust our raw data to better reflect the most recent changes
                                    in local and
                                    national industry markets. We accomplish this by integrating additional Census
                                    Bureau data with
                                    our proprietary content, allowing us to accelerate and refine month-to-month trends.
                                    Our content
                                    displays the new data in three ways:
                                  <ul>
                                    <li> Our employment data is adjusted to better reflect the most
                                      recent realities at local and national levels </li>
                                    <li> Updates of industry market sales averages and total
                                      market volume are accelerated by one month and renamed as Trailing Twelve Month
                                      (TTM) values</li>
                                    <li> New content will display monthly (not annual) industry sales and employment
                                      from year-end 2019 through
                                      both Preliminary Update and Advance Projection months. </li>
                                  </ul>
                                  These enhanced protocols will be most obvious in
                                  our Industry Market Trend series, including a new "Monthly Change" tab in each report.
                                  Similarly,
                                  snapshot reports like the SWOT-XPRESS, Competitive Market Narrative and Company
                                  Insight series will
                                  reflect our new update protocols and add content for Preliminary Update and Advance
                                  months.
                                  Shorter projections are more detailed and accurate than longer-term projections.
                                  Preliminary Update
                                  data is calculated on a more accurate and detailed basis than the Advance Projection
                                  month, which will
                                  adjust as it moves to "update month" status the following month. Interpret and utilize
                                  this content accordingly.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  computed: {
    ...mapState({
      covid: (state) => state.user.market_report.data.data['covid'],
      covidColumns: (state) =>
        state.user.market_report.data.data['covidColumns'],
      covidChange: (state) => state.user.market_report.data.data['covidChange'],
      covidChangeColumns: (state) =>
        state.user.market_report.data.data['covidChangeColumns'],
    }),
  },
  props: ['headerData'],
  data() {
    return {
      newCovid: [],
      monthsCovidColumns: [],
      yearsCovidColumns: [],
      newCovidChange: [],
      monthsCovidColumnsChange: [],
      yearsCovidColumnsChange: [],
      view: 'tableDataMarketAnnualSalesy',
      showDialog: false,
      tableDataMarketCovidImpact: [],
      tableDataMarketCovidImpactChange: [],
      covidImpactChangeLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
      names: [],
    };
  },
  mounted() {
   
    
    this.buildEmploymentSalesDataMonthToMonth();
    this.buildEmploymentSalesDataChangeFromDec19();
   

    let section = this.$route.query.section;

    if (!section) {
      section = 'tableDataMarketAnnualSales';
    }

    this.switchView(section);
    this.tableDataMarketCovidImpact = this.covidColumns.map((name, index) => ({
      name,
      dates: Object.values(this.covid).map((item) => item[index]),
    }));
    this.names = Object.keys(this.covid);
    this.tableDataMarketCovidImpactChange = Object.entries(
      this.covidChange
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.covidImpactChangeLineChart.data = {
      labels: this.covidChangeColumns,
      series: this.tableDataMarketCovidImpactChange.map((item) => ({
        name: item.name,
        data: item.dates.map((i) => Number(i.replace('%', ''))),
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'tableDataMarketAnnualSales';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    groupBy: function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || [])[x.year] = x;
        return rv;
      }, {});
    },
    buildEmploymentSalesDataMonthToMonth: function(){
      let i = 0;
      let covidAux = this.covidColumns;
      this.newCovid = covidAux.map(item => {
        let aux = {
          Employment: this.covid.Employment[i],
          Sales: this.covid['Average Monthly Site Sales'][i],
          month: item.split('-')[0],
          year: item.split('-')[1],
          monthOrder: this.checkMonth(item.split('-')[0],),
        }
        i++;
        return aux;
      });

      this.newCovid.forEach(item => {
        this.monthsCovidColumns.push({ month: item.month, index: this.checkMonth(item.month) })
        if (item.year != 19)
          this.yearsCovidColumns.push(item.year)
      })

      this.yearsCovidColumns = this.yearsCovidColumns.filter((el, i) => this.yearsCovidColumns.indexOf(el) === i);

      this.monthsCovidColumns = this.monthsCovidColumns.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null))


      this.newCovid.sort((a, b) => a.monthOrder - b.monthOrder);

      this.newCovid = this.groupBy(this.newCovid, 'month')

      Object.keys(this.newCovid).forEach((index, item) => {
        for (let i = 0; i < this.yearsCovidColumns.length; i++) {
          if (!this.newCovid[index][this.yearsCovidColumns[i]]) {
            this.newCovid[index][this.yearsCovidColumns[i]] = {
              Employment: '',
              Sales: '',
              year: this.yearsCovidColumns[i],
              month: index,
            }
          }

        }
      })   
    },
    buildEmploymentSalesDataChangeFromDec19: function(){
      let i = 0;
      let covidAux = this.covidChangeColumns;
      this.newCovidChange = covidAux.map(item => {
        let aux = {
          Employment: this.covidChange.Employment[i],
          Sales: this.covidChange['Average Monthly Site Sales'][i],
          month: item.split('-')[0],
          year: item.split('-')[1],
          monthOrder: this.checkMonth(item.split('-')[0],),
        }
        i++;
        return aux;
      });

      this.newCovidChange.forEach(item => {
        this.monthsCovidColumnsChange.push({ month: item.month, index: this.checkMonth(item.month) })
        if (item.year != 19)
          this.yearsCovidColumnsChange.push(item.year)
      })

      this.yearsCovidColumnsChange = this.yearsCovidColumnsChange.filter((el, i) => this.yearsCovidColumnsChange.indexOf(el) === i);

      this.monthsCovidColumnsChange = this.monthsCovidColumnsChange.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null))


      this.newCovidChange.sort((a, b) => a.monthOrder - b.monthOrder);

      this.newCovidChange = this.groupBy(this.newCovidChange, 'month')

      Object.keys(this.newCovidChange).forEach((index, item) => {
        for (let i = 0; i < this.yearsCovidColumnsChange.length; i++) {
          if (!this.newCovidChange[index][this.yearsCovidColumnsChange[i]]) {
            this.newCovidChange[index][this.yearsCovidColumnsChange[i]] = {
              Employment: '',
              Sales: '',
              year: this.yearsCovidColumnsChange[i],
              month: index,
            }
          }

        }
      })   

    },
    checkMonth: function(month) {
        switch(month){
          case 'Jan':
            return 1;
          case 'Feb':
            return 2;
          case 'Mar':
            return 3;
          case 'Apr':
            return 4;
          case 'May':
            return 5;
          case 'Jun':
            return 6;
          case 'Jul':
            return 7;
          case 'Aug':
            return 8;
          case 'Sep':
            return 9;
          case 'Oct':
            return 10;
          case 'Nov':
            return 11;
          case 'Dec':
            return 12;
        }
    }
  },
};
</script>

